// ============================================================
// YUKLEMEDEN ONCE GORSEL KUCULTME
//
// 2026-09-11 denetimi: haber gorselleri sunucuya 0,5-1,2 MB'lik PNG
// olarak gidiyordu (ekran goruntusu / afis). Telefonda mobil veride
// yavas aciliyor, haber detayinda gorsel cizilene kadar sayfanin bir
// kismi bembeyaz kaliyordu.
//
// Artik panelden yuklenen her gorsel, sunucuya gitmeden once tarayicida:
//   - uzun kenari en fazla MAKS_KENAR piksele indirilir,
//   - saydam pikseli yoksa JPEG'e cevrilir (PNG afisler ~5-10 kat kuculur),
//   - saydamsa (logo vb.) PNG olarak kalir, yalnizca boyutu kuculur.
// Gorsel olmayan dosyalar (PDF, mp3, video), GIF ve SVG oldugu gibi gider.
// Kucultme bir sebeple basarisiz olursa asil dosya yuklenir; yukleme
// asla bu adim yuzunden engellenmez.
// ============================================================

import { UPLOAD_BASE } from "helpers/api_config";

export const MAKS_KENAR = 1600;
export const JPEG_KALITESI = 0.82;
// Bu boyutun altindaki ve zaten kucuk olan gorsellere dokunulmaz
const KUCUK_DOSYA = 200 * 1024;

const KUCULTULEBILIR = /^image\/(jpeg|jpg|png|webp|bmp)$/i;

const resmiYukle = file =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = e => { URL.revokeObjectURL(url); reject(e); };
    img.src = url;
  });

const saydamMi = (ctx, w, h) => {
  // Buyuk gorsellerde her pikseli taramak gereksiz; seyrek ornekleme yeter
  const veri = ctx.getImageData(0, 0, w, h).data;
  const adim = Math.max(4, Math.floor((w * h) / 40000) * 4);
  for (let i = 3; i < veri.length; i += adim) {
    if (veri[i] < 250) return true;
  }
  return false;
};

const blobaCevir = (canvas, tur, kalite) =>
  new Promise(resolve => canvas.toBlob(resolve, tur, kalite));

const uzantiliAd = (ad, uzanti) => {
  const temel = String(ad || "gorsel").replace(/\.[^.]+$/, "");
  return `${temel}.${uzanti}`;
};

/**
 * @param {File|Blob} file
 * @returns {Promise<File|Blob>} kucultulmus dosya ya da (gerek yoksa / hata olursa) asil dosya
 */
export async function gorseliKucult(file) {
  try {
    if (!file || !KUCULTULEBILIR.test(file.type || "")) return file;
    if (typeof document === "undefined" || typeof URL === "undefined") return file;

    const img = await resmiYukle(file);
    const enUzun = Math.max(img.naturalWidth, img.naturalHeight);
    if (!enUzun) return file;
    if (enUzun <= MAKS_KENAR && file.size <= KUCUK_DOSYA) return file;

    const oran = Math.min(1, MAKS_KENAR / enUzun);
    const w = Math.max(1, Math.round(img.naturalWidth * oran));
    const h = Math.max(1, Math.round(img.naturalHeight * oran));

    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext("2d");
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(img, 0, 0, w, h);

    const pngKalsin = /png|webp/i.test(file.type) && saydamMi(ctx, w, h);
    let blob;
    if (pngKalsin) {
      blob = await blobaCevir(canvas, "image/png");
    } else {
      // JPEG'de saydam alan siyaha donmesin diye beyaz zemin
      ctx.globalCompositeOperation = "destination-over";
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, w, h);
      blob = await blobaCevir(canvas, "image/jpeg", JPEG_KALITESI);
    }

    // Donusum dosyayi buyuttuyse (zaten iyi sikistirilmis JPEG) asli kalsin
    if (!blob || blob.size >= file.size) return file;

    const ad = uzantiliAd(file.name, pngKalsin ? "png" : "jpg");
    try {
      return new File([blob], ad, { type: blob.type, lastModified: Date.now() });
    } catch (e) {
      // Eski tarayicilarda File yapicisi yoksa ad bilgisiyle Blob gonder
      blob.name = ad;
      return blob;
    }
  } catch (e) {
    console.warn("Görsel küçültülemedi, asıl dosya yükleniyor:", e);
    return file;
  }
}

/**
 * react-dropzone-uploader icin ortak getUploadParams.
 * Sayfalardaki kopya fonksiyonlarin yerine gecer.
 */
export const gorselYuklemeParametreleri = async ({ file }) => {
  const yuklenecek = await gorseliKucult(file);
  const body = new FormData();
  body.append("dataFile", yuklenecek, yuklenecek.name || (file && file.name) || "dosya");
  return { url: `${UPLOAD_BASE}/uploadfile`, body };
};
